/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useContext, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
// import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
// import {ID, KTIcon, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {UpdateInvitationsAPI, deleteVisitorpanel} from '../../core/_requests'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { ID, KTIcon, QUERIES } from '../../../../../../_metronic/helpers'
import Dropdown from 'react-bootstrap/Dropdown';
import { UserContext } from '../../../../../../contextStore'

type Props = {
  id: any
  value:any
}

const VisitorpanelActionsCell: FC<Props> = ({id,value}) => {
  const {setItemIdForUpdate,itemIdForUpdate} = useListView()
  const { userDetail, chapterID, reload ,setMessage} = useContext(UserContext);

  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => deleteVisitorpanel(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.VISITORPANELS_LIST}-${query}`])
    },
  })
  const UpdateStatus=async (status:any)=>{
      await UpdateInvitationsAPI({status,id}).then((res:any)=>{
        if(res?.data ){
          // resetForm()
          // navigate('/visitor-panel')
          setMessage('success', 'Invitations Update successfully')
          queryClient.invalidateQueries([`${QUERIES.VISITORPANELS_LIST}-${query}`])

          // handleClose()
        }
      }).catch((error:any)=>{
        //console.log("error",error)
        if (error?.response?.data?.error?.message) {
          //console.log("error?.response?",error?.response?.status)
          if(error?.response?.status == 500 )
          {
          setMessage('error', 'Something went wrong')
          }else{

            setMessage('error', error?.response?.data?.error?.message)
          }
        } else {
          setMessage('error', 'Something went wrong')
        }
      })
  }

  // const UpdateStatus = async (id:any)=>{

  // }


  return (
    <>
    <Dropdown>
      <Dropdown.Toggle id="dropdown-basic" > 
      {value == 1 ?  "Invite" : value == 2 ? "Attended": value  == 3 ? "Not Attended ":"-" }
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item  className='menu-item px-3' onClick={()=>{UpdateStatus(1)}} active={value==1} >Invite</Dropdown.Item>
        <Dropdown.Item  className='menu-item px-3' onClick={()=>{UpdateStatus(2)}}  active={value==2} >Attended</Dropdown.Item>
        <Dropdown.Item   className='menu-item px-3' onClick={()=>{UpdateStatus(3)}} active={value==3} >Not Attended</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      {/* <a
        href='#'
        className='btn btn-light btn-active-light-primary fs-5 btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Attended
        <KTIcon iconName='down' className='fs-5 m-0' />
      </a> */}
      {/* begin::Menu */}
      {/* <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-5 w-200px py-4'
        data-kt-menu='true'
      > */}
        {/* begin::Menu item */}
        {/* <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Invite
          </a>
        </div> */}


        {/* end::Menu item */}
        {/* <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Attended
          </a>
        </div> */}


        {/* begin::Menu item */}
        {/* <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-visitorpanels-table-filter='delete_row'
            onClick={async () => await deleteItem.mutateAsync()}
          >
            Not Attended
          </a>
        </div> */}
        {/* end::Menu item */}
      {/* </div> */}
      {/* end::Menu */}
    </>
  )
}

export {VisitorpanelActionsCell}
